/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { searchForm, createAnswer } from "module/actions";
import { exists, getFormId, getLocaleToCreateContent } from "application/functions";
import Form from "module/components/form/form";
import Loading from "application/components/loading";
import { adaptFormToBack } from "module/create-answer-logic/adaptFormToBack";
import { clone } from "ramda";
import cleanEmptyImages from "module/functions/cleanEmptyImages";

const MainModulePage = (props) => {
  const { searchForm, form, adaptedForm, createAnswer, createdAnswerId, loading } = props;
  const [sentData, setSentData] = useState({});
  const [paypalData, setPaypalData] = useState(null);
  const [deletedProducts, setDeletedProducts] = useState([]);
  useEffect(() => {
    searchForm(getFormId());
  }, [searchForm]);

  useEffect(() => {
    if (paypalData) {
      changeAnswer(paypalData.id, paypalData.money);
    }
  }, [paypalData]);

  const onSubmit = (value) => {
    const newValue = clone(value);
    newValue.garment = value.garment.filter(function (g, index) {
      return deletedProducts.indexOf(index) === -1;
    });

    setSentData(cleanEmptyImages(newValue));

    let content;
    if (createdAnswerId.id) {
      content = adaptFormToBack(newValue, form, getLocaleToCreateContent(form), createdAnswerId.id, false);
    } else {
      content = adaptFormToBack(newValue, form, getLocaleToCreateContent(form), null, false);
    }
    createAnswer({
      content,
    });
  };

  const changeAnswer = (id, money) => {
    const newForm = clone(sentData);
    if (id) {
      newForm.paypal_transaction_id = { value: id };
    }
    if (money) {
      newForm.money = { value: money };
    }
    const content = adaptFormToBack(newForm, form, getLocaleToCreateContent(form), createdAnswerId.id, true);
    createAnswer({
      content,
    });
  };

  if (!exists(form)) {
    return <Loading />;
  }

  return (
    <Fragment>
      <Form
        form={adaptedForm}
        onSubmit={onSubmit}
        defaultValue={""}
        changeAnswer={(id, money) => setPaypalData({ id, money })}
        deletedProducts={deletedProducts}
        setDeletedProducts={setDeletedProducts}
        createdAnswerId={createdAnswerId}
        loading={loading}
      />
    </Fragment>
  );
};

const stateToProps = (state) => {
  return {
    form: state.ModuleReducers.form,
    adaptedForm: state.ModuleReducers.adaptedForm,
    answer: state.ModuleReducers.answer,
    createdAnswerId: state.ModuleReducers.createdAnswerId,
    loading: state.ModuleReducers.loading,
  };
};

const dispatchToProps = (dispatch) => {
  return {
    searchForm: (id) => dispatch(searchForm(id)),
    createAnswer: (content) => dispatch(createAnswer(content)),
  };
};

export default connect(stateToProps, dispatchToProps)(MainModulePage);
